exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  width: 70%;\n  margin-left: 15%;\n  margin-top: 2em;\n}\nform .help {\n  padding-left: 1.7em;\n  margin-top: -1em;\n}\n.networkname-text-input {\n  width: 20em;\n}\nsection .half-text-width {\n  width: 50%;\n}\nsection .btn-small {\n  margin-bottom: 12px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/sysman/src/app/sysman-network-config/sysman-network-config.component.less
// module id = 1472
// module chunks = 2